import ShPopConfirm from '@/components/Helpers/ShPopConfirm';
import ParsedDayScheduleCalendar from '@/components/Common/ParsedDayScheduleCalendar';
import holidayStatusMap from './holidayStatusMap';
import typeHolidayMap from './typeHolidayMap';
import holidayElementMap from './holidayElementMap';

// @vue/component
export default {
  name: 'HolidaysListItem',

  components: {
    ShPopConfirm,
    ParsedDayScheduleCalendar,
    holidayStatusMap,
    typeHolidayMap,
    holidayElementMap,
  },

  props: {
    holiday: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      activeTypes: [],
    };
  },

  methods: {
    handleEditHoliday() {
      this.$emit('editHoliday', this.holiday);
    },
    async handleDeleteHoliday() {
      await this.$store.dispatch('client/project/holidays/removeHoliday', { holiday: this.holiday.uuid});
      this.$emit('refreshList');
      this.$message({
        message: 'Pomyślnie dezaktywowano Święto',
        type: 'success',
      });
    },

    getLighterColorForStatus() {
      const color = require('color');
      return color(holidayStatusMap[this.holiday.holiday_status || 'past_holiday'].color).lighten(0.55);
    },
    getDarkenColorForStatus() {
      const color = require('color');
      return color(holidayStatusMap[this.holiday.holiday_status || 'past_holiday'].color).darken(0.3);
    },
    getTextForStatus() {
      return holidayStatusMap[this.holiday.holiday_status || 'past_holiday'].text;
    },
    getTextForType() {
      return typeHolidayMap[this.holiday.type || 'regular'].text;
    },
    getTextForElement() {
      return holidayElementMap[this.holiday.element].text;
    },
  },
};
